import { createApp } from "vue";
import i18n from "./i18n";

import App from "./App.vue";
import RenderVNode from "@/components/RenderVNode";
import FactsheetBadge from "@/components/FactsheetApp/FactsheetBadge";

i18n.global.locale.value = window.curLanguage;

const app = createApp(App);
app.component("render-vnode", RenderVNode);
app.component("factsheet-badge", FactsheetBadge);
app.use(i18n).mount("#website");
